import { z } from 'zod'
import { useZodForm, validateEmissionDate, requiredNumber } from '@minetrace/ui/forms'

export const step4IgafomSchema = z.object({
  presentationDate: z.string().min(1, 'Fecha de emision es requerida'),
  // Caducidad: opcional aquí — la validación condicional (requerida para
  // formalizado + máx 5 años, observación 9) se hace en Step4Igafom porque
  // depende de minerSource que el esquema no conoce.
  expirationDate: z.string().optional(),
  fileNumber: z.string().min(1, 'N° Expediente es requerido'),
  type: z.number().min(1, 'Tipo de IGAFOM es requerido'),
  documentStatus: z.number().min(1, 'Estado documento es requerido'),
  exploitationMethod: z.number().min(1, 'Metodo de explotacion es requerido'),
  substanceId: z.number().min(1, 'Tipo de sustancia es requerido'),
  // Producción diaria estimada por derecho minero (observación 3/12).
  productiveCapacity: requiredNumber('Producción diaria estimada es requerida'),
}).superRefine((data, ctx) => {
  validateEmissionDate(data.presentationDate, 'presentationDate', ctx)
})

export type Step4IgafomFormValues = z.infer<typeof step4IgafomSchema>

const defaultValues: Step4IgafomFormValues = {
  presentationDate: '',
  expirationDate: '',
  fileNumber: '',
  type: 0,
  documentStatus: 0,
  exploitationMethod: 0,
  substanceId: 0,
  productiveCapacity: 0,
}

export const useStep4IgafomForm = (props?: { defaultValues?: Step4IgafomFormValues; disabled?: boolean }) => {
  return useZodForm<Step4IgafomFormValues>({
    validationSchema: step4IgafomSchema,
    defaultValues: { ...defaultValues, ...props?.defaultValues },
  })
}
